import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=abfb71a4&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('abfb71a4')) {
      api.createRecord('abfb71a4', component.options)
    } else {
      api.reload('abfb71a4', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=abfb71a4&", function () {
      api.rerender('abfb71a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20n1FVUAtIkjU/JS/comp/ImgFallback2.vue"
export default component.exports